/* @flow strict */

import { RoutesType } from 'client/src/routes';
import CheckIn from './index';

export const CheckInRoutes: RoutesType = [
  {
    Component: CheckIn,
      params: {
        path: '/check-in/:eventId?'
      }
  }
];
